<template>
  <div class="container-component">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ContainerComponent'
  }
</script>

<style lang="scss" scoped>
.container-component {
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  overflow-y: scroll;
  padding: 32px;
  background-color: white;
  @include max-width(414) {
    padding: 16px;
  }
}
</style>